<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item
            icons
            router
            :to="item.path"
            v-for="item in racourcis"
            :key="item.text"
            :disabled="item.disabled"
            >{{ item.text }}</v-breadcrumbs-item
          >
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <!-- BTN AJOUT -->
    <v-spacer></v-spacer>
    <div class="text-xs-right">
      <v-tooltip top>
        <v-btn
          slot="activator"
          icons
          color="primary"
          @click.stop="newBesoin()"
          dark
        >
          Ajouter
          <v-icon right>add</v-icon> </v-btn
        >Ajouter un nouveau besoin
      </v-tooltip>
    </div>

    <!-- MENU PRINCIPAL -->
    <v-card-text>
      <el-row :gutter="20">
        <!-- MENU DE GAUCHE -->
        <div class="grid-content">
          <el-row>
            <el-col>
              <el-card class="box-card">
                <!-- MENU BESOIN -->
                <v-layout row justify>
                  <!-- BESOIN EN ATTENTE -->
                  <v-flex md12 style="padding: 10px">
                    <el-button type="warning" size="medium" class="btnV"
                      >BESOIN EN ATTENTE</el-button
                    >
                    <v-layout row justify>
                      <v-flex xs12 style="padding: 10px">
                        <el-card class="box-card">
                          <div v-if="activDerouler" class="mb-1">
                            <el-popover
                              ref="popover5"
                              placement="top"
                              width="180"
                              trigger="hover"
                            >
                              <p>Veuillez choisir le format d'impression ?</p>
                              <div
                                style="text-align: right; margin: 0"
                                v-if="!disabledImprime"
                              >
                                <el-button
                                  type="success"
                                  size="mini"
                                  v-if="droitAcces.imprime_pdf_besoin_liste"
                                  @click="imprimeListeBesoin('PDF')"
                                  >PDF</el-button
                                >
                                <el-button
                                  type="primary"
                                  v-if="droitAcces.imprime_exc_besoin_liste"
                                  size="mini"
                                  @click="imprimeListeBesoin('EXC')"
                                  >EXCEL</el-button
                                >
                              </div>
                            </el-popover>
                            <div>
                              <el-button
                                v-popover:popover5
                                type="warning"
                                :disabled="disabledImprime"
                                icon="el-icon-printer"
                                >Imprimer la liste</el-button
                              >
                            </div>
                          </div>
                          <v-flex xs12 class="text-xs-right">
                            <v-tooltip bottom>
                                <v-btn class="elevation-3" slot="activator" @click="loadRecentBesoin()" dark icon flat color="primary">
                                    <v-icon>cached</v-icon>
                                </v-btn>
                                actualiser la liste
                            </v-tooltip>
                          </v-flex>

                          <!-- <v-tooltip top>
                          <v-btn v-if="!choix" slot="activator" icons color="indigo" @click.stop="showDialogComparaison(besoinCourant); verifPrioriteBesoin(); " dark>Comparer <v-icon right>shopping_cart</v-icon></v-btn>
                          Comparer les prix fournisseurs
                          </v-tooltip> -->

                          <!--<v-tooltip top>-->
                          <!--<v-btn v-if="!choix" slot="activator" icons color="indigo" @click.stop="showDialogComparaison(besoinCourant); verifPrioriteBesoin(); " dark>Comparer <v-icon right>shopping_cart</v-icon></v-btn>-->
                          <!--Comparer les prix fournisseurs-->
                          <!--</v-tooltip>-->

                          <el-collapse accordion @change="activationDerouler()">
                            <el-collapse-item name="1">
                              <template slot="title">
                                VEUILLEZ CLIQUER POUR DEROULER SVP
                                <transition name="el-fade-in-linear">
                                  <v-badge
                                    left
                                    v-show="!activDerouler"
                                    class="notification"
                                  >
                                    <span slot="badge" style="margin-top: -11px">{{ notification }}</span>
                                    <v-icon large color="grey lighten-1"
                                      >notifications_active</v-icon
                                    >Besoin(s) non traitée(s)
                                  </v-badge>
                                </transition>
                              </template>
                              <v-container fluid grid-list-md>
                                <div>
                                  <el-tabs v-model="tab" type="border-card">
                                    <!-- LISTE DES DEMANDES APPROUVEES -->
                                    <el-tab-pane>
                                      <span slot="label">
                                        <i class="el-icon-tickets"></i>
                                        LISTE DES 10 DERNIERES DEMANDES
                                        APPROUVEES
                                      </span>
                                      <v-spacer></v-spacer>
                                      <v-flex xs12>
                                        <v-layout row class="mb-4 mt-1">
                                          <v-flex xs5 class="mr-1">
                                            <el-select
                                              @clear="clearSelect()"
                                              @change="filtrerEntrepot"
                                              clearable
                                              filterable
                                              v-model="selectDemande"
                                              placeholder="Filtrer par demande de maintenance"
                                              style="width:100%"
                                            >
                                              <el-option
                                                v-for="item in listDemande"
                                                :key="item.id"
                                                :label="item.libelle"
                                                :value="item.id"
                                              ></el-option>
                                            </el-select>
                                          </v-flex>

                                          <v-tooltip top v-if="droitAcces.index_besoin_commande">
                                            <v-btn
                                              v-if="
                                                !choix &&
                                                  this.nombreSelection
                                                    .length === 1
                                              "
                                              slot="activator"
                                              icons
                                              color="green"
                                              @click.stop="
                                                verifPrioriteBesoin();
                                                showFormCommandNew();
                                                loadFourn();
                                              "
                                              dark
                                            >
                                              Commander
                                              <v-icon right
                                                >shopping_cart</v-icon
                                              > </v-btn
                                            >Passer une Commander
                                          </v-tooltip>

                                          <v-tooltip top v-if="droitAcces.index_besoin_commande">
                                            <v-btn
                                              v-if="
                                                !choix &&
                                                  this.nombreSelection.length >=
                                                    2
                                              "
                                              slot="activator"
                                              icons
                                              color="green"
                                              @click.stop="
                                                verifPrioriteBesoin();
                                                showFormCommande();
                                                loadFourn();
                                              "
                                              dark
                                            >
                                              Commander
                                              <v-icon right
                                                >shopping_cart</v-icon
                                              > </v-btn
                                            >Passer un Commander
                                          </v-tooltip>

                                          <v-tooltip top>
                                            <v-btn
                                              v-if="!choix"
                                              slot="activator"
                                              @click.stop="deleteNeed()"
                                              icons
                                              dark
                                              color="red"
                                            >
                                              Supprimer
                                              <v-icon dark
                                                >delete</v-icon
                                              > </v-btn
                                            >Suppression de la selection
                                          </v-tooltip>

                                        </v-layout>

                                        <v-layout row class="mb-3 mt-1">
                                          <v-flex md4 class="mr-1">
                                            <el-select
                                              clearable
                                              filterable
                                              v-on:change="loadChantier();filtreByProjet(projetS)"
                                              v-model="projetS"
                                              placeholder="Selectionner de Projet"
                                              style="width:100%"
                                            >
                                              <el-option
                                                v-for="item in listeProjet"
                                                :key="item.id"
                                                :label="item.libelle"
                                                :value="item.id"
                                              ></el-option>
                                            </el-select>
                                          </v-flex>

                                          <v-flex md4 class="mr-1">
                                            <el-select
                                              clearable
                                              filterable
                                              v-on:change="loadTravaux();filtreByChantier(chantierS)"
                                              v-model="chantierS"
                                              placeholder="Selectionner un Chantier"
                                              style="width:100%"
                                            >
                                              <el-option
                                                v-for="item in listeChantier"
                                                :key="item.id"
                                                :label="item.libelle"
                                                :value="item.id"
                                              ></el-option>
                                            </el-select>
                                          </v-flex>

                                          <v-flex md4 class="mr-1">
                                            <el-select
                                              @clear="clearSelect()"
                                              clearable
                                              filterable
                                              @change="filtrerTravaux(travauxS)"
                                              v-model="travauxS"
                                              placeholder="Selectionner un Chantier les travaux"
                                              style="width:100%"
                                            >
                                              <el-option
                                                v-for="item in listeTravaux"
                                                :key="item.id"
                                                :label="item.libelle"
                                                :value="item.id"
                                              ></el-option>
                                            </el-select>
                                          </v-flex>
                                        </v-layout>
                                        <!-- Creation de filtre -->
                                        <v-layout row class="mb-3 mt-1">
                                          <v-flex>
                                            <el-select
                                              clearable
                                              filterable
                                              @clear="clearSelect()"
                                              @change="filtrerEtatService"
                                              v-model="selectEtatService"
                                              placeholder="Filtrer par service"
                                            >
                                              <el-option
                                                v-for="item in comboService"
                                                :key="item.serviceId"
                                                :label="item.serviceLibelle"
                                                :value="item.serviceId"
                                              ></el-option>
                                            </el-select>

                                            <el-select
                                              clearable
                                              filterable
                                              @clear="clearSelect()"
                                              @change="filtrerEtatDemandeur"
                                              v-model="selectEtatDemandeur"
                                              placeholder="Filtrer par demandeur"
                                            >
                                              <el-option
                                                v-for="item in comboUser"
                                                :key="item.userId"
                                                :label="item.userName"
                                                :value="item.userId"
                                              ></el-option>
                                            </el-select>

                                            <el-date-picker
                                              clearable
                                              @clear="clearSelect()"
                                              @change="filtrerEtatDate"
                                              v-model="selectEtatDate"
                                              type="daterange"
                                              range-separator="à"
                                              start-placeholder="date de debut"
                                              end-placeholder="date de fin"
                                              value-format="dd-MM-yyyy"
                                              format="dd-MM-yyyy"
                                            ></el-date-picker>

                                            <el-select
                                              clearable
                                              filterable
                                              @clear="clearSelect()"
                                              @change="
                                                filtrerEtatPrioriteBesoin
                                              "
                                              v-model="selectEtatPrioriteBesoin"
                                              placeholder="Filtrer par priorité"
                                            >
                                              <el-option
                                                v-for="item in priorites"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                              ></el-option>
                                            </el-select>
                                            <!-- <v-flex xs12 class="mr-1">
                                            <div class="text-xs-right"> -->
                                            <v-tooltip top>
                                              <v-btn
                                                slot="activator"
                                                @click="loadBesoin()"
                                                fab
                                                dark
                                                small
                                                color="#2196f3"
                                              >
                                                <v-icon dark>search</v-icon>
                                              </v-btn>
                                              Afficher la liste de tous les
                                              besoins
                                            </v-tooltip>
                                            <!-- </div>
                                        </v-flex> -->
                                          </v-flex>
                                        </v-layout>
                                      </v-flex>
                                      <!-- <v-card-title>
                                        
                                      </v-card-title> -->
                                      <data-tables
                                        highlight-current-row
                                        ref="multipleTable"
                                        @selection-change="handleSelectionChange"
                                        :data="listBesoin"
                                        stripe
                                        border
                                        height="350"
                                        style="width: 100%"
                                      >
                                        <el-table-column v-if="droitAcces.new_besoin_commande"
                                          :selectable="besoinSelect"
                                          width="55"
                                          type="selection"
                                        ></el-table-column>
                                        
                                        <el-table-column
                                          prop="ressource"
                                          label="Produit / Référence"
                                          sortable
                                          width="300"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              outline
                                              text-color="primary"
                                              label
                                              color="primary"
                                              >{{ scope.row.produit }} /
                                              {{ scope.row.ref }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="libelleTrx"
                                          label="Projet/Chantier/Travaux/Tache"
                                          width="300"
                                        ></el-table-column>

                                        <el-table-column
                                          prop="priorite"
                                          sortable
                                          label="Priorite"
                                          width="100"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="green accent-3"
                                              v-if="scope.row.priorite === 1"
                                              >Faible</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="orange accent-4"
                                              v-else-if="
                                                scope.row.priorite === 2
                                              "
                                              >Normal</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="red accent-3"
                                              v-else-if="
                                                scope.row.priorite === 3
                                              "
                                              >Urgent</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="blue lighten-4"
                                              v-else
                                              >Aucune</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="qte"
                                          label="Quantité demandé"
                                          width="180"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              color="primary"
                                              >{{ scope.row.qte }}</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              color="red"
                                              >{{ scope.row.unite }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="date"
                                          sortable
                                          label="Date de création"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{ scope.row.date }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          sortable
                                          prop="date"
                                          label="Date livraison souhaitée"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{
                                                scope.row.dateLivrSouh
                                              }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="user"
                                          label="Emis par"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{ scope.row.user }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                         <el-table-column
                                          prop="userValider"
                                          label="Valider par"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="warning"
                                              >{{ scope.row.userValider }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        
                                      </data-tables>
                                    </el-tab-pane>

                                    <!--LISTE DES DEMANDES EN ATTENTE DE CONFIRMATION-->
                                    <el-tab-pane>
                                      <span slot="label">
                                        <i class="el-icon-tickets"></i> LISTE
                                        DES 10 DERNIERES DEMANDES EN ATTENTE DE
                                        CONFIRMATION
                                      </span>
                                      <v-spacer></v-spacer>
                                        <!-- :data="listBesoinAttente"
                                        border
                                        height="350"
                                        style="width: 100%" -->
                                        <v-tooltip top class="text-xs-right">
                                              <v-btn
                                                slot="activator"
                                                @click="loadBesoin()"
                                                fab
                                                dark
                                                small
                                                color="#2196f3"
                                              >
                                                <v-icon dark>search</v-icon>
                                              </v-btn>
                                              Afficher la liste de tous les
                                              besoins en attente de confirmation
                                            </v-tooltip>
                                      <data-tables tables mt-3 ml-1 mr-1  ref="multipleTable" @selection-change="handleSelectionChange" :data="listBesoinAttente" style="width:100%;">
                                        <el-table-column
                                          prop="type"
                                          label="Type ressource"
                                          sortable
                                          width="140"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              outline
                                              text-color="primary"
                                              label
                                              color="primary"
                                              >{{ scope.row.type }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <!-- <el-table-column :selectable="besoinSelect" width="55"  type="selection"></el-table-column> -->
                                        <el-table-column
                                          prop="produit"
                                          label="Ressource / Référence"
                                          sortable
                                          width="350"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              outline
                                              text-color="primary"
                                              label
                                              color="primary"
                                              >{{ scope.row.produit }} /
                                              {{ scope.row.ref }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>

                                        <el-table-column
                                          sortable
                                          prop="priorite"
                                          label="Priorite"
                                          width="100"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="green accent-3"
                                              v-if="scope.row.priorite === 1"
                                              >Faible</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="orange accent-4"
                                              v-else-if="
                                                scope.row.priorite === 2
                                              "
                                              >Normal</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="red accent-3"
                                              v-else-if="
                                                scope.row.priorite === 3
                                              "
                                              >Urgent</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              label
                                              fab
                                              color="blue lighten-4"
                                              v-else
                                              >Aucune</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="qte"
                                          label="Quantité demandé"
                                          width="180"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              color="secondary"
                                              >{{ scope.row.qte }}</v-chip
                                            >
                                            <v-chip
                                              text-color="white"
                                              color="red"
                                              >{{ scope.row.unite }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          sortable
                                          prop="date"
                                          label="Date de création"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{ scope.row.date }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          sortable
                                          prop="date"
                                          label="Date livraison souhaitée"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{
                                                scope.row.dateLivrSouh
                                              }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="user"
                                          label="Emis par"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{ scope.row.user }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="commChefProj"
                                          label="Commentaire validation chef projet"
                                          width="200"
                                        ></el-table-column>
                                        <el-table-column
                                          prop="serviceLibelle"
                                          label="Service"
                                          width="200"
                                        >
                                          <template slot-scope="scope">
                                            <v-chip
                                              text-color="white"
                                              label
                                              color="primary"
                                              >{{
                                                scope.row.serviceLibelle
                                              }}</v-chip
                                            >
                                          </template>
                                        </el-table-column>
                                        <el-table-column
                                          prop="libelleTrx"
                                          label="Projet/Chantier/Travaux"
                                          width="300"
                                        ></el-table-column>
                                        <el-table-column
                                          prop="libEntrepot"
                                          label="Magasin chantier"
                                          width="300"
                                        ></el-table-column>

                                        <el-table-column
                                          label="Actions"
                                          width="100"
                                          fixed="right"
                                        >
                                          <template slot-scope="scope">
                                             <v-tooltip bottom v-if="scope.row.travauxId != '' ">
                                              <v-btn
                                                icons
                                                color="primary"
                                                slot="activator"
                                                fab
                                                 @click="editRessources(scope.row)"
                                                dark
                                                small
                                              >
                                                <v-icon>edit</v-icon>
                                              </v-btn>
                                              Modifier
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                              <v-btn
                                                icons
                                                color="red"
                                                slot="activator"
                                                fab
                                                @click.stop="
                                                  dialogSupr = true;
                                                  idBesoin = scope.row;
                                                "
                                                dark
                                                small
                                              >
                                                <v-icon>delete</v-icon>
                                              </v-btn>
                                              supprimer cette demande
                                            </v-tooltip>
                                          </template>
                                        </el-table-column>
                                      </data-tables>
                                    </el-tab-pane>
                                    <!-- FIN LISTE DES TÂCHES-->
                                  </el-tabs>
                                </div>
                              </v-container>
                            </el-collapse-item>
                          </el-collapse>
                        </el-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <v-layout row justify v-if="droitAcces.index_besoin_commande">
                  <!-- COMMANDE NON TRAITE -->
                  <v-flex md12 style="padding: 10px">
                    <el-button type="primary" size="medium" class="btnV"
                      >COMMANDE NON TRAITE</el-button
                    >

                    <v-layout row justify>
                      <v-flex xs12 style="padding: 10px">
                        <el-card class="box-card">
                          <el-collapse accordion>
                            <el-collapse-item name="1">
                              <template slot="title">
                                VEUILLEZ CLIQUER POUR DEROULER SVP
                                   <transition name="el-fade-in-linear">
                                  <v-badge
                                    left
                                    v-show="!activDerouler"
                                    class="notification"
                                  >
                                    <span slot="badge" style="margin-top: -11px">{{ notifCommande }}</span>
                                    <v-icon large color="grey lighten-1"
                                      >notifications_active</v-icon
                                    >Commande(s) non traitée(s)
                                  </v-badge>
                                </transition>
                              </template>
                              <!-- Creation de filtre commande -->
                              <div>
                                <v-layout row class="mb-3 mt-1">
                                  <v-flex xs5 class="mr-1">
                                    <el-select
                                      @clear="clearSelect()"
                                      @change="filtrerCmdEntrepot"
                                      clearable
                                      filterable
                                      v-model="selectDemande"
                                      placeholder="Filtrer par demande de maintenance"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listDemande"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </v-flex>
                                </v-layout>
                                <v-layout row class="mb-3 mt-1">
                                  <v-flex md4 class="mr-1">
                                    <el-select
                                      clearable
                                      filterable
                                      v-on:change="loadChantier()"
                                      v-model="projetS"
                                      placeholder="Selectionner de Projet"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeProjet"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </v-flex>
                                  <v-flex md4 class="mr-1">
                                    <el-select
                                      clearable
                                      filterable
                                      v-on:change="loadTravaux()"
                                      v-model="chantierS"
                                      placeholder="Selectionner un Chantier"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeChantier"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </v-flex>
                                  <v-flex md4 class="mr-1">
                                    <el-select
                                      @clear="clearSelectCommande()"
                                      clearable
                                      filterable
                                      @change="filtrerCommandeTravaux"
                                      v-model="travauxS"
                                      placeholder="Selectionner un Chantier les travaux"
                                      style="width:100%"
                                    >
                                      <el-option
                                        v-for="item in listeTravaux"
                                        :key="item.id"
                                        :label="item.libelle"
                                        :value="item.id"
                                      ></el-option>
                                    </el-select>
                                  </v-flex>
                                </v-layout>

                                <v-layout row class="mb-3 mt-1">
                                  <v-flex md3 class="mr-1">
                                    <el-select
                                      clearable
                                      filterable
                                      @clear="clearSelectCommande()"
                                      @change="filtrerEtatPrioriteCommande"
                                      v-model="selectEtatPrioriteCommande"
                                      placeholder="Filtrer par priorité"
                                    >
                                      <el-option
                                        v-for="item in priorites"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                      ></el-option>
                                    </el-select>
                                  </v-flex>

                                  <v-flex md3>
                                    <el-date-picker
                                      clearable
                                      @clear="clearSelectCommande()"
                                      @change="filtrerEtatDateCommande"
                                      v-model="selectEtatDateCommande"
                                      type="daterange"
                                      range-separator="à"
                                      start-placeholder="date de debut"
                                      end-placeholder="date de fin"
                                      value-format="dd-MM-yyyy"
                                      format="dd-MM-yyyy"
                                    ></el-date-picker>
                                  </v-flex>
                                  <v-flex xs12 class="mr-1">
                                    <div class="text-xs-right">
                                      <v-tooltip top>
                                        <v-btn
                                          slot="activator"
                                          @click="loadCommande()"
                                          fab
                                          dark
                                          small
                                          color="#2196f3"
                                        >
                                          <v-icon dark>search</v-icon>
                                        </v-btn>
                                        Afficher la liste de toutes les
                                        commandes
                                      </v-tooltip>
                                    </div>
                                  </v-flex>
                                </v-layout>
                                <data-tables tables mt-3 ml-1 mr-1  ref="multipleTable" @selection-change="handleSelectionChange" :data="listCommande" style="width:100%;"
                                  :default-sort="{
                                    prop: 'libelle',
                                    order: 'descending'
                                  }">
                                  <el-table-column
                                    prop="libelle"
                                    label="Libellé"
                                    width="280"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        outline
                                        text-color="primary"
                                        label
                                        color="primary"
                                        >{{ scope.row.libelle }}</v-chip
                                      >
                                    </template>
                                  </el-table-column>
                                    <el-table-column prop="comparateur" label="Comparateur" width="150">
                                      <template v-if="scope.row.comparateur == 2" slot-scope="scope">
                                          <a href="#" >
                                              <v-avatar  :tile="true" size="50px" height="50px" color="grey lighten-4"> <img src="static/validComparateur.png" ></v-avatar>
                                          </a>
                                      </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="priorite"
                                    label="Priorite"
                                    width="100"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="green accent-3"
                                        v-if="scope.row.priorite === 1"
                                      >
                                        Faible
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="orange accent-4"
                                        v-else-if="scope.row.priorite === 2"
                                      >
                                        Normal
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="red accent-3"
                                        v-else-if="scope.row.priorite === 3"
                                      >
                                        Urgent
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="blue lighten-4"
                                        v-else
                                      >
                                        Aucune
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="totalCommande"
                                    label="Quantité demandé"
                                    width="180"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        color="secondary"
                                      >
                                        {{ scope.row.totalCommande }}
                                      </v-chip>
                                      <v-chip text-color="white" color="red">
                                        {{ scope.row.unite }}
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="dateJour"
                                    label="Date de création"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="primary"
                                      >
                                        {{ scope.row.dateJour }}
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="dateLivr"
                                    label="Date livraison souhaitée"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="primary"
                                      >
                                        {{ scope.row.dateLivr }}
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="user"
                                    label="Emis par"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="primary"
                                      >
                                        {{ scope.row.user }}
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="commChefProj"
                                    label="Commentaire validation chef projet"
                                    width="200"
                                  >
                                  </el-table-column>
                                  <el-table-column
                                    prop="serviceLibelle"
                                    label="Service"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="primary"
                                      >
                                        {{ scope.row.serviceLibelle }}
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="libelleTrx"
                                    label="Projet/Chantier/Travaux"
                                    width="300"
                                  >
                                  </el-table-column>
                                  <el-table-column
                                    prop="priorite"
                                    label="Priorite"
                                    width="100"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="green accent-3"
                                        v-if="scope.row.priorite == '1'"
                                        >Faible</v-chip
                                      >
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="orange accent-4"
                                        v-else-if="scope.row.priorite == '2'"
                                        >Normale</v-chip
                                      >
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="red accent-3"
                                        v-else-if="scope.row.priorite == '3'"
                                        >Urgent</v-chip
                                      >
                                      <v-chip
                                        text-color="white"
                                        label
                                        fab
                                        color="blue lighten-4"
                                        v-else
                                        >Aucune</v-chip
                                      >
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="dateC"
                                    label="Date de création"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        outline
                                        text-color="primary"
                                        label
                                        color="primary"
                                        >{{ scope.row.dateC }}</v-chip
                                      >
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="user"
                                    label="Emise par"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="primary"
                                        >{{ scope.row.user }}</v-chip
                                      >
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="fournisseur"
                                    label="Fournisseur"
                                    width="200"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="primary"
                                        >{{ scope.row.fournisseurNom }}</v-chip
                                      >
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="etat"
                                    label="Etat"
                                    width="280"
                                  >
                                    <template slot-scope="scope">
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="orange"
                                        v-if="scope.row.factureValide === 0"
                                      >
                                         FACTURE EN ATTENTE DE VALIDATION
                                        <v-icon right></v-icon>
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="green"
                                        v-if="scope.row.factureValide === 1"
                                      >
                                        FACTURE VALIDE
                                        <v-icon right></v-icon>
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="red"
                                        v-if="scope.row.factureValide === 2"
                                      >
                                        FACTURE REJETE
                                        <v-icon right></v-icon>
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="red"
                                        v-if="scope.row.etat === false"
                                      >
                                        NON LIVRE
                                        <v-icon right></v-icon>
                                      </v-chip>
                                      <v-chip
                                        text-color="white"
                                        label
                                        color="green"
                                        v-if="scope.row.etat == true"
                                      >
                                        LIVRE EN TOTALITE
                                        <v-icon right></v-icon>
                                      </v-chip>
                                    </template>
                                  </el-table-column>
                                  <el-table-column
                                    prop="libelleTrx"
                                    label="Projet/Chantier/Travaux"
                                    width="300"
                                  ></el-table-column>
                                  <el-table-column
                                    prop="libEntrepot"
                                    label="Entrepot"
                                    width="300"
                                  ></el-table-column>
                                  <el-table-column label="Action" fixed="right">
                                    <template slot-scope="scope">
                                      <div class="text-xs-center">
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            @click.stop="
                                              showCommande(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="green"
                                          >
                                            <v-icon dark
                                              >folder_open</v-icon
                                            > </v-btn
                                          >Détails
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            v-show="
                                              (scope.row.factureValide === 0 ||
                                                scope.row.factureValide === 2) && scope.row.comparateur == 0
                                            "
                                            @click.stop="
                                              editCommande(scope.row)
                                            "
                                            fab
                                            dark
                                            small
                                            color="primary"
                                          >
                                            <v-icon dark>edit</v-icon> </v-btn
                                          >Modifier
                                        </v-tooltip>
                                        <v-tooltip top>
                                          <v-btn
                                            slot="activator"
                                            v-if="
                                              droitAcces.delete_option_commande
                                            "
                                            v-show="
                                              scope.row.factureValide === 0 ||
                                                scope.row.factureValide === 2
                                            "
                                            @click.stop="
                                              dialogCOmmande = true;
                                              idCommande = scope.row;
                                            "
                                            fab
                                            dark
                                            small
                                            color="red"
                                          >
                                            <v-icon dark>delete</v-icon> </v-btn
                                          >Supprimer
                                        </v-tooltip>
                                      </div>
                                    </template>
                                  </el-table-column>
                                </data-tables>
                              </div>
                            </el-collapse-item>
                            <!-- <p align="center" v-else>
                            <v-chip text-color="white" label color="red" style="width: 100%; font-size: 23px">
                                    VOUS N'AVEZ PAS LES AUTORISATIONS REQUISES POUR ACCEDER AUX COMMANDES NON TRAITES.
                                    <v-icon dark right>stop_screen_share</v-icon>
                            </v-chip>
                            </p>-->
                          </el-collapse>
                        </el-card>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-row>
    </v-card-text>

    <!-- MODAL AJOUT DE BESOIN -->
    <v-dialog
      v-model="dialogBesoin"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter des besoins</span>
            <span v-if="dialogEdit">Modification du besoin</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogBesoin = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip text-color="white" label color="primary" style="width:100%">
              DETAILS ASSOCIE AU BESOIN
              <v-icon right>shopping_cart</v-icon>
            </v-chip>
          </p>
          <v-layout row>
            <v-flex xs6>
              <div style="margin-top: 20px">
                <el-radio-group v-model="typeDmd" size="mini">
                  <el-radio-button label="Projet"></el-radio-button>
                  <el-radio-button label="Magasin chantier"></el-radio-button>
                  <el-radio-button label="Autre"></el-radio-button>
                </el-radio-group>
              </div>
            </v-flex>
          </v-layout>

          <v-form
            v-model="valid"
            ref="formBesoin"
            lazy-validation
            id="formBesoin"
          >
            <v-container fluid grid-list-md>
              <v-layout row v-show="typeDmd == 'Projet'">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Projet concerné *</span>
                    <el-select
                      filterable
                      v-on:change="loadChantier()"
                      v-model="projetS"
                      placeholder="Type de Projet"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listeProjet"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>

                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chantier concerné *</span>
                    <el-select
                      filterable
                      v-on:change="loadTravaux()"
                      v-model="chantierS"
                      placeholder="Chantier concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listeChantier"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Travaux *</span>
                    <el-select
                      filterable
                      v-on:change="loadTacheTrx()"
                      v-model="travauxS"
                      placeholder="Travaux"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listeTravaux"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>

                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Tâches *</span>
                    <el-select
                      filterable
                      v-model="tacheS"
                      placeholder="Tache"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listeTacheTrx"
                        :key="item.idOptTrx"
                        :label="item.libelle"
                        :value="item.idOptTrx"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
             
              <!-- MODAL EDIT RESSOURCES -->
              <v-dialog
                v-model="dialogShowEditRessource"
                max-width="78%"
                :overlay="true"
                scrollable
                persistent
              >
                <v-card>
                  <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title
                      >Modifier le produit de la tâche
                      {{ tacheSelectioner.libelleTrx }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialogShowEditRessource = false" dark>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text>
                    <el-row :gutter="20">
                      <div class="grid-content" style=" padding: 3px">
                        <el-row>
                          <el-card class="box-card">
                            <div class="grid-content bg-purple">
                              <div class="text item">
                                <el-form
                                  id="formEditRessource"
                                  label-width="90px"
                                  :model="formEditRessource"
                                  ref="formEditRessource"
                                  class="demo-form-inline"
                                >
                                  <v-layout row justify>
                                    <v-flex md6>
                                      <el-form-item
                                        label="Produit"
                                        style="width:100%"
                                      >
                                      <el-input
                                        type="text"
                                        name="libelle"
                                        disabled
                                        v-model="formEditRessource.libelle"
                                        style="width:100%"
                                      ></el-input>
                                      </el-form-item>
                                    </v-flex>
                                    <v-flex md6>
                                      <el-form-item
                                        label="Quantité"
                                        required
                                        style="width:100%"
                                      >
                                        <el-input
                                        type="number"
                                        name="qte"
                                        :min=0
                                        v-model="formEditRessource.qte"
                                        style="width:100%"
                                      ></el-input>
                                      </el-form-item>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout row justify v-if="tacheSelectioner.type == 'VÉHICULE' ||
                                        tacheSelectioner.type == 'Vehicule'">
                                    <v-flex md6>
                                      <el-form-item
                                        required
                                        label="Date debut"
                                        style="width:100%"
                                      >
                                      <el-input
                                        type="date"
                                        name="dateD"
                                        v-model="formEditRessource.dateD"
                                        style="width:100%"
                                      ></el-input>
                                      </el-form-item>
                                    </v-flex>
                                    <v-flex md6>
                                      <el-form-item
                                        label="Date fin"
                                        required
                                        style="width:100%"
                                      >
                                        <el-input
                                        type="date"
                                        name="dateF"
                                        v-model="formEditRessource.dateF"
                                        style="width:100%"
                                      ></el-input>
                                      </el-form-item>
                                    </v-flex>
                                  </v-layout>
                                </el-form>
                              </div>
                            </div>
                          </el-card>
                        </el-row>
                      </div>
                      <br />
                    </el-row>
                    <v-flex xs12 class="text-xs-right">
                    <v-tooltip top >
                      <v-btn
                        slot="activator"
                        icons
                        color="orange"
                        @click="resetFormEditRess()"
                        dark
                      >
                        Fermer
                        <v-icon right>close</v-icon> </v-btn
                      >Fermer
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        icons
                        color="primary"
                        :disabled="loading"
                        @click.stop="sumbitRessource(tacheSelectioner)"
                        dark
                      >
                        Enregistrer
                        <v-icon right>save</v-icon> </v-btn
                      >Enregistrer
                    </v-tooltip>
                    </v-flex>

                  </v-card-text>
                  <div style="flex: 1 1 auto;"></div>
                </v-card>
              </v-dialog>

              <!-- MAINTENANCE -->
              <v-layout v-show="typeDmd == 'Magasin chantier'" row>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Magasin chantier *</span>
                    <el-select
                      v-model="selectDemande"
                      placeholder="Magasin chantier concerné"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listDemande"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout>
                <div class="block">
                  <span class="demonstration">Date le livraison souhaitée</span>
                  <el-date-picker
                    style="width:100%"
                    format="dd-MM-yyyy"
                    value-format="yyyy-MM-dd"
                    id="dateLivrSouh"
                    v-model="dateLivrSouh"
                    type="date"
                    placeholder="Choisissez une date de livraison"
                  ></el-date-picker>
                </div>
              </v-layout>

              <v-layout row>
                <v-flex md11>
                  <p align="center">
                    <v-chip
                      outline
                      text-color="primary"
                      label
                      color="primary"
                      style="width:100%"
                    >
                      AJOUTER LES LIGNES DE VOTRE BESOIN
                      <v-icon right>shopping_cart</v-icon>
                    </v-chip>
                  </p>
                </v-flex>
                <v-flex md1></v-flex>
              </v-layout>

             <v-flex xs12 class="text-xs-right" v-if="droitAcces.index_type_tache && droitAcces.create_new_product">
                  <v-tooltip top>
                        <input
                          name="fileInputExcel"
                          type="file"
                          style="display:none"
                          ref="fileInputExcel"
                          accept="image/*"
                          v-on:change="onFileExcelPicked"
                        />
                        <v-btn
                            v-if="true"
                            slot="activator"
                            color="green"
                            @click.stop="$refs.fileInputExcel.click()"
                            dark
                        >
                            Importer
                            <v-icon right>file_download</v-icon>
                        </v-btn>Importer fichier excel
                  </v-tooltip>

                    <v-tooltip top>
                  <v-btn
                      v-if="true"
                      slot="activator"
                      color="orange"
                      @click.stop="dialogImport = true"
                      dark
                  >
                      Générer
                      <v-icon right>file_upload</v-icon>
                  </v-btn>Générer un modèle
                  </v-tooltip>
              </v-flex>
              <v-flex md18>
                <v-layout row v-for="(optionP) in optionProduit" :key="optionP.key">
                  <v-flex md6>
                    <span class="demonstration">Type ressource *</span>
                    <el-select
                      name="valeurSelect"
                      id="valeurSelect"
                      v-model="optionP.type"
                      filterable
                      v-on:change="loadTypeProduit(optionP.type)"
                      placeholder="Type ressource"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTypeRessource"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.libelle"
                      >
                      </el-option>

                    </el-select>
                  </v-flex>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Ressource *</span>
                      <el-select
                        v-model="optionP.produit"
                        filterable
                        v-on:change="loadUniteProduit(optionP.produit)"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listeProduitAffich"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Quantité *</span>
                      <el-input
                        type="number"
                        min="1"
                        v-model="optionP.qte"
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Unité *</span>
                      <el-input type="text" name="valeurSelect" :readonly="true" v-model="valeurUniteMateriel" style="width:100%"></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Priotié *</span>
                      <el-select
                        name="priorite"
                        id="priorite"
                        v-model="optionP.priorite"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in priorites"
                          :key="item.value"
                          :label="item.label"
                          :value="item.label"
                        ></el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md1 class="text-xs-left">
                    <v-btn
                      icons
                      color="primary"
                      @click="addListInventaire(optionP)"
                      fab
                      small
                      dark
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
              <el-form
                label-position="top"
                :inline="true"
                :model="formInventaire"
                class="demo-form-inline"
              >
                <br />

                <v-layout row>
                  <el-table :data="tableInventaire" style="width: 100%">
                    <el-table-column
                      prop="type"
                      label="Type ressource"
                      sortable
                    >
                    </el-table-column>
                    <el-table-column prop="libelle" label="Libellé" sortable>
                    </el-table-column>
                    <el-table-column prop="qte" label="Quantité">
                    </el-table-column>
                    <el-table-column prop="unite" label="Unité">
                    </el-table-column>
                    <el-table-column prop="priorite" label="Priorité">
                    </el-table-column>

                    <el-table-column label="Operations">
                      <template slot-scope="scope">
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            fab
                            small
                            icons
                            color="red"
                            @click.native.prevent="
                              deleteRow(scope.$index, tableInventaire)
                            "
                            dark
                          >
                            <v-icon center>delete</v-icon>
                          </v-btn>
                          Supprimer
                        </v-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </v-layout>
              </el-form>
            </v-container>

            <v-btn @click="dialogBesoin = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn
              icons
              color="blue"
              @click="submitBesoin"
              :disabled="loading"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon>
            </v-btn>
            <!--<v-btn-->
            <!--icons-->
            <!--color="blue"-->
            <!--@click="submitBesoin"-->
            <!--:disabled="!valid"-->
            <!--dark-->
            <!--&gt;-->
            <!--Modifier-->
            <!--<v-icon right>edit</v-icon>-->
            <!--</v-btn>-->
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE COMMANDE -->
    <v-dialog
      v-model="dialogComm"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit != true">Ajouter une nouvelle commande</span>
            <span v-if="dialogEdit">Modification de la commande</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogComm = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip text-color="white" label color="primary" style="width:100%">
              DETAILS ASSOCIE A LA COMMANDE
              <v-icon right>shopping_cart</v-icon>
            </v-chip>
          </p>
          <v-flex xs12 class="text-xs-right">
             <v-tooltip top>
                <v-btn slot="activator" icons color="indigo" id="intro" @click.stop="imprimerListe()" dark>Info <v-icon right>print</v-icon></v-btn>
                Imprimer la liste des fournisseurs pour ces produits
                </v-tooltip>
             <v-tooltip top>
                <v-btn slot="activator" icons color="orange" id="intro" @click.stop="showDialogComparaison(); verifPrioriteBesoin(); " dark>Comparer <v-icon right>compare</v-icon></v-btn>
                Comparer les prix fournisseurs
                </v-tooltip>
                <v-tooltip top>
                <v-btn slot="activator" icons color="info" id="intro" @click.stop="genererListe()" dark>Extraire <v-icon right>file_upload</v-icon></v-btn>
                Extraire en excel les lignes de besoins
                </v-tooltip>
            </v-flex>
          <v-form v-model="valid" ref="formComm" lazy-validation id="formComm">
            <v-container fluid grid-list-md>
              <v-layout row>

                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Intitulé de la commande *</span>
                    <el-input
                      name="libelle"
                      placeholder="Intitulé de la commande"
                      v-model="libelle"
                      style="width:100%"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de livraison *</span>
                    <el-date-picker
                      v-model="dateLivr"
                      name="dateLivr"
                      id="dateLivr"
                       format="dd-MM-yyyy"
                      value-format="dd-MM-yyyy"
                      type="date"
                      placeholder="Date de livraison"
                      style="width: 100%"
                    ></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Priorité commande</span>
                    <el-select
                      v-model="priorite"
                      required
                      placeholder="Priorite"
                      :disabled="disabledChamp"
                    >
                      <el-option
                        v-for="item in priorites"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
                 <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Fournisseur *</span>
                    <el-select
                      @change="handleChangeFour"
                      v-model="selectFourn"
                      filterable
                      placeholder="Fournisseur"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listFour"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row v-if="entrepotLib =='' && idTravaux !=''">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Projet concerné</span>
                    <el-input
                      v-model="projetLib"
                      placeholder="Projet"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Chantier concerné</span>
                    <el-input
                      v-model="chantieretLib"
                      placeholder="Chantier"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Travaux</span>
                    <el-input
                      v-model="travuxLib"
                      placeholder="Travaux"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

                <v-layout row v-if="entrepotLib !=''">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Magasin concerné</span>
                    <el-input
                      v-model="entrepotLib"
                      placeholder="Entrepot"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

                <v-layout row v-if="entrepotLib =='' && idTravaux ==''">
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Autre</span>
                    <el-input value="Autre"
                      placeholder="AUTRE"
                      style="width:100%"
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <p align="center">
                <v-chip
                  outline
                  text-color="primary"
                  label
                  color="primary"
                  style="width:100%"
                >
                  AJOUTER LES LIGNES DE VOTRE COMMANDE
                  <v-icon right>shopping_cart</v-icon>
                </v-chip>
              </p>

              <v-layout
                row
                v-for="(optionCom, index) in optionCommande"
                :key="optionCom.key"
              >
              <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Code gestion</span>
                    <el-autocomplete
                      v-model="optionCom.codeGestion"
                      name="codeGestion"
                      placeholder="Code gestion"
                      :prop="'optionCommande.' + index + '.codeGestion'"
                      required
                      width="100%" 
                      :readonly="true"
                    ></el-autocomplete>
                  </div>
                </v-flex>

                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Ressource *</span>
                    <el-autocomplete
                      v-model="optionCom.produit"
                      :fetch-suggestions="loadProduit"
                      name="produit"
                      placeholder="Ressource"
                      :prop="'optionCommande.' + index + '.produit'"
                      required
                      width="100%" 
                      :readonly="true"
                    ></el-autocomplete>
                  </div>
                </v-flex>
                <v-flex md1>
                  <div class="block">
                    <span class="demonstration">Quantité *</span>
                    <el-input
                      type="number"
                      @change="calculTotalComm(index)"
                      :min="1"
                      value="qte"
                      :prop="'optionCommande.' + index + '.qte'"
                      placeholder="Quantité"
                      v-model="optionCom.qte"
                      width="100%" 
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Prix unitaire *</span>
                    <el-input
                      type="number"
                      @change="calculTotalComm(index)"
                      value="prix"
                      :prop="'optionCommande.' + index + '.prix'"
                      placeholder="Prix"
                      v-model="optionCom.prix"
                      width="100%" 
                      :readonly="disabledChamp"
                    ></el-input>
                  </div>
                </v-flex>
                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Unité</span>
                    <el-input
                      class="inline-input"
                      v-model="optionCom.unite"
                      :prop="'optionCommande.' + index + '.unite'"
                      required
                      :trigger-on-focus="true"
                      width="100%" 
                      :readonly="true"
                    ></el-input>
                  </div>
                </v-flex>

                <v-flex md2>
                  <div class="block">
                    <span class="demonstration">Priorité</span>
                    <el-select
                      v-model="optionCom.priorite"
                      :prop="'optionCommande.' + index + '.priorite'"
                      :trigger-on-focus="true"
                      :disabled="disabledChamp"
                    >
                      <el-option
                        v-for="item in priorites"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br />
            </v-container>

            <v-btn @click="dialogComm = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn
              v-if="dialogEdit != true"
              icons
              color="blue"
              @click="submitComm"
              :disabled="loading"
              dark
            >
              Enregistrer
              <v-icon right>save</v-icon>
            </v-btn>
            <v-btn
              v-if="dialogEdit"
              icons
              color="blue"
              @click="submitComm"
              submitBesoin
              :disabled="loading"
              dark
            >
              Modifier
              <v-icon right>edit</v-icon>
            </v-btn>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


      <!-- MODAL IMPORTATION BESOIN -->
    <v-dialog v-model="dialogImport" max-width="50%" :overlay="true" scrollable persistent>
    <v-card>
      <v-card-text text-xs-center>
        <h4 align="center">Nb: Le fichier contient uniquement les ressources qui figurent dans votre liste de Ressources.</h4>
        <h4 align="center">Indiquer uniquement la QUANTITE de chaque ligne de produit que vous souhaitez demander.</h4>
        <h3 align="center">Supprimer ensuite les lignes restantes dans votre fichier avant importation.</h3>
        <p align="center">
          <v-btn @click.native="dialogImport = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
          <v-btn icons color="green" @click.stop="generateFileExcel()" dark>Généner <v-icon right>done</v-icon></v-btn>
        </p>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
    </v-dialog>


    <!-- Detail de la commande -->
    <ModalCommandeDetails
      :detailCommande="detailCommande"
      :show="showModalDetailCom"
      @close="showModalDetailCom = false"
    ></ModalCommandeDetails>
    <!-- Detail de la commande -->

    <!-- Modification de la commande -->
    <ModalCommandeMAJ
      :detailCommande="detailCommande"
      :show="showModalModifCom"
      @close="
        showModalModifCom = false;
        loadCommandeRecent();
      "
    ></ModalCommandeMAJ>
    <!-- Modification de la commande -->

    <!-- Detail de la commamde initial -->
    <ModalComparateurCmd
      :typeCommande="2"
      :infOrenseigner="infOrenseigner"
      :commandeDeriv="commandeDeriv"
      :commandeDerivDeux="commandeDerivDeux"
      :mntTotalCmd="mntTotalCmd"
      :nbCommandeSug="nbCommandeSug"
      :nbCommandeSugDeux="nbCommandeSugDeux"
      :show="showModalCompCmd"
      @close="loadCommandeRecent();
        showModalCompCmd = false;
      "
    ></ModalComparateurCmd>
    <!-- Detail de la commamde initial -->

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSupr"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h3>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteBesoin" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogCOmmande"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h3 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h3>
          <p align="center">
            <v-btn @click.native="dialogCOmmande = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteCommande" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import ModalCommandeDetails from "@/components/besoin/ModalCommandeDetails";
import ModalCommandeMAJ from "@/components/besoin/ModalCommandeMAJ";
import ModalComparateurCmd from "@/components/comparateur/ModalComparateurCmd";
// function FrontImage (){
//    $("#intro").fadeOut(900).delay(300).fadeIn(800);
// }
//    $(document).ready(function(){
//     setInterval('FrontImage()',2200);
// });
export default {
  components: {
    Loading,
    ModalCommandeDetails,
    ModalCommandeMAJ,
    ModalComparateurCmd
  },
  name: "Besoin",
  data() {
    return {
      notif: JSON.parse(sessionStorage.getItem("sessionNotif")),
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
      droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
      loading: false,
      valid: true,
      factNull: false,
      choix: true,
      racourcis: [
        { path: "/", text: "Accueil", disabled: false },
        { path: "/projet", text: "Liste des besoins", disabled: true }
      ],
      priorites: [
        {
          value: 1,
          label: "Faible"
        },
        {
          value: 2,
          label: "Normal"
        },
        {
          value: 3,
          label: "Urgent"
        }
      ],
      EtatConfirmation: [
        {
          value: 0,
          label: "Approuvé"
        },
        {
          value: 1,
          label: "En attente"
        }
      ],

      notification: 0,
      notifCommande: 0,
      showModalDetailCom: false,
      selectEtatPrioriteBesoin: null,
      selectEtatConfirmationBesoin: null,
      oldComboUser: [],
      otpionBesoinSelect: [],
      selectEtatService: null,
      comboService: [],
      fileExcel: [],
      idBesoin: "",
      idCommande: "",
      dialogSupr: false,
      dialogCOmmande: false,
      disabledBtnValide: true,
      dialogBesoin: false,
      dialogComm: false,
      dialogEdit: false,
      listBesoin: [],
      dialogShowEditRessource: false,
      tacheSelectioner: [],
       formEditRessource: {
        id:'',
        libelle:'',
        qte:0,
        dateF:'',
        dateD:''
      },
      etat: 0,
      nombreSelection: 0,
      optionBesoin: [
        { type: "", key: 1, value: "", qte: 1, unite: "", id: "", priorite: 1 }
      ],
      optionProduit: [
        { type: "", key: 1, produit: "", qte: 1, unite: "", priorite: "" }
      ],
      listProd: [],
      listTypeRessource: [],
      libelle: "",
      dateLivr: "",
      selectFourn: "",
      priorite: 1,
      besoinCourant: [],
      listeProduitAffich: [],
      infOrenseigner: [{
        libelle: '',
        dateLivr: '',
        priorite: '',
      }],
      optionCommande: [
        {
          key: 1,
          produit: "",
          codeGestion: "",
          prix: 0,
          qte: 1,
          tva: 0,
          total: 0,
          id: "",
          priorite: 1
        }
      ],
      totalComTTC: 0,
      totComLigneTTCFormat: 0,
      totalComHT: 0,
      entrepotId:'',
      totalComTVA: 0,
      totComLigneTTC: 0,
      listFour: [],
      formInventaire: {},
      dialogImport: false,
      tableInventaire: [],
      selectFourn: "",
      listCommande: [],
      detailCommande: null,
      //filtre
      oldListBesoin: [],
      produitUnite: "",
      listBesoinAttente: [],
      tab: "",

      selectEtatDemandeur: null,
      selectEtatDate: null,

      comboUser: [],
      dateCreated: "",
      typeProduit: "",
      oldListCommande: [],
      selectEtatPrioriteCommande: null,
      selectEtatDateCommande: null,
      activDerouler: false,
      disabledImprime: true,
      showModalModifCom: false,
      //Projet
      listeProjet: [],
      listeChantier: [],
      listeTravaux: [],
      listeTacheTrx: [],

      temp: [],
      projetS: "",
      chantierS: "",
      travauxS: "",
      tacheS: "",
      valeurUniteMateriel: "",
      commandeDeriv: [],
      commandeDerivDeux: [],
      showModalCompCmd: false,
      dialogDetailCmd: false,
      mntTotalCmd: "",
      nbCommandeSug: 0,
      nbCommandeSugDeux: 0,
      typeDmd: "Projet",
      listDemande: [],
      selectDemande: "",

      //Passez une commande
      disabledChamp: false,

      dateLivrSouh: null,

      //details de commande
      idTravaux:'',
      projetLib: "",
      chantieretLib: "",
      entrepotLib: '',
      travuxLib: ""
    };
  },

  methods: {
    deleteBesoin(item) {
      this.loading = true;
      let formData = new FormData();
      formData.append("userConnect", this.user.id);
      let url =
        this.domaine + "optionbesoin/delete/" + this.idBesoin.id + "/demande";
      this.$http.post(url, formData).then(
        response => {
          this.loading = false;
          this.$message({
            type: "success",
            duration: 5000,
            message: response.body.message
          });
          this.dialogSupr = false;

          this.loadRecentBesoin();
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors de la suppression "
          );
        }
      );
    },
    //recherche le prix fournisseur pour les produits selection
    handleChangeFour(idFour) {
      let url = this.domaine + "fournisseur/info/produit";

      let data = new FormData();

      let produits = new Array();
      let i;
      for (i = 0; i < this.optionCommande.length; i++) {
        produits[i] = this.optionCommande[i].idProd;
      }

      data.append("produits", produits);
      data.append("fournisseur", idFour);

      this.$http.post(url, data).then(
        response => {
          let produits = response.body.produits;

          this.optionCommande.forEach((item, index, array, $this) => {
            let $idProd = item.idProd;
            let produitFind = produits.find(prod => {
              return prod.id == $idProd;
            });

            array[index].prix = produitFind.prix;
          });
        },
        error => {}
      );
    },
    loadTypeRessource() {
      let url =this.domaine + "product/typeRessource";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTypeRessource = response.body.types;
            this.loading = false;
          }
        });
      },

    //afficher le formulaire d'une commande
    showFormCommande() {
      //on determine le nombre de produit corespondant
      let comp = 0;
      let temp = [];
      this.factNull = false;
            console.log(',dd',this.multipleSelection.length)
      this.optionCommande.splice(0);
      for (let index = 0; index < this.multipleSelection.length; index++) {
        let element1 = this.multipleSelection[0]["travauxId"];
        // let element2 = this.multipleSelection[0]["idProd"];
        let magasin1 = this.multipleSelection[0]["entrepotId"];
        const element = this.multipleSelection[index]["travauxId"];
        const element2 = this.multipleSelection[index]["entrepotId"];
        this.multipleSelection[0]['idTravaux'] = element
        this.multipleSelection[0]['entrepotId'] = element2
        if(element1 !=''){
            if (element1 == element) {
              comp++;
            } else {
            this.factNull = true;
          }
        }else{
          if (magasin1 == element2) {
              comp++;
            } else {
            this.factNull = true;
            this.$refs.multipleTable.toggleRowSelection(
              this.multipleSelection[index]
            );
          }
        }
      }
      // if (this.multipleSelection.length == comp && this.factNull === false) {
      
      // } else {
      //   this.otpionBesoinSelect.push()
      //   // this.$notify({
      //   //     title: "Fusion",
      //   //     message: "Impossible de lier ces besoins pour la commande. Veuillez selectionnez des besoins émit pour les mêmes Travaux / pour les mêmes entrepots",
      //   //     type: "error",
      //   //     position: "top-center"
      //   //   });
      // }
      let multipleSelection1 = this.multipleSelection;

        var tableau = multipleSelection1;
        for (var i = 0; i < tableau.length; ++i) {
          for (var j = i + 1; j < tableau.length; ++j) {
            if (tableau[i].idProd === tableau[j].idProd) {
              let data = { 'origin': tableau[i].id, 'add': tableau[j].id };
              this.otpionBesoinSelect.push(data);            

              tableau[i].qte = tableau[i].qte + tableau[j].qte;
              tableau.splice(j--, 1);
            }
          }
        }
       
        let groupedData = {};    
        console.log('this',this.otpionBesoinSelect)
        this.otpionBesoinSelect.forEach(item => {  
          if (groupedData.hasOwnProperty(item.origin)) {    
            groupedData[item.origin].add.push(item.add);
          } else {
            groupedData[item.origin] = { origin: item.origin, add: [item.add] };
          }
        });
        let groupedArray = Object.values(groupedData);

        this.otpionBesoinSelect = groupedArray        
        this.optionCommande = tableau;
        // this.idTravaux = this.multipleSelection[0]['idTravaux']
        this.idTravaux = this.multipleSelection[0]['idTravaux']
        this.entrepotId = this.multipleSelection[0]['entrepotId']
        this.projetLib = this.multipleSelection[0]["projet"];
        this.chantieretLib = this.multipleSelection[0]["chantier"];
        this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
        this.travuxLib = this.multipleSelection[0]["travaux"];
        this.libelle =''
        this.selectFourn=''
        this.dialogComm = true;
        this.disabledChamp = false;          
    },

    //afficher le formulaire d'une commande
    showFormCommandNew() {
      //  recuperation des produits concerne
      this.optionCommande.splice(0);
      this.multipleSelection.forEach(optionbesoin => {
        this.optionCommande.push(optionbesoin);
      }, this);
      this.idTravaux = this.multipleSelection[0]['idTravaux']
      this.projetLib = this.multipleSelection[0]["projet"];
      this.chantieretLib = this.multipleSelection[0]["chantier"];
      this.travuxLib = this.multipleSelection[0]["travaux"];
      this.dateLivr = this.multipleSelection[0]["dateLivrSouh"];
      this.entrepotLib = this.multipleSelection[0]["libEntrepot"];
      this.libelle =''
      this.selectFourn=''
      this.dialogComm = true;
      this.disabledChamp = false;
    },

    //Action methodes
    showCommande(ligneCommande) {
      this.disabledChamp = true;
      this.showModalDetailCom = true;
      this.detailCommande = ligneCommande;
    },

    editCommande(ligneCommande) {
      this.showModalModifCom = true;
      this.detailCommande = ligneCommande;
    },
    deleteCommande() {
      this.loading = true;
      let url = this.domaine + "besoin/delete/comd/" + this.idCommande.id;
      this.$http.get(url).then(response => {
        if (response.body) {
          this.$notify({
            title: "SUPPRESSION",
            message: "Commande supprimé avec succès.",
            type: "success",
            position: "top-center"
          });
          this.dialogCOmmande = false;
          this.dialogSupr = false;
          this.loading = false;
          this.loadCommandeRecent();
          this.loadRecentBesoin();
        } else {
          this.$message.error("Impossible de supprimer");
          this.loading = false;
        }
      },
      (error) => {
        this.$message.error("Impossible de supprimer");
          this.loading = false;
      });
    },
    //Controlle de l'activation du boutton deroulez
    activationDerouler() {
      this.activDerouler
        ? (this.activDerouler = false)
        : (this.activDerouler = true);
      //enregistrement des besoins ayant été vue par l'utilisateur
      if (this.activDerouler && this.listBesoin.length > 0)
        this.enregistrementBesoinVue();
    },

    enregistrementBesoinVue() {
      let url = this.domaine + "besoin/save/checked/" + this.user.id + "/show";
      this.$http.get(url);
    },

    //filtre commande
    clearSelectCommande() {
      this.listCommande = this.oldListCommande;
    },

    filtrerEtatDateCommande(date) {
      this.selectEtatPrioriteCommande = null;
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(commande => {
        if (commande.dateJour >= date[0] && commande.dateJour <= date[1])
          return commande.dateJour;
        else if (commande.dateJour == date[0] && commande.dateJour == date[1])
          return commande.dateJour;
      });
    },

    filtrerEtatPrioriteCommande(priorite) {
      //reinitialisation de la liste commande
      this.listCommande = this.oldListCommande;
      this.selectEtatDateCommande = null;

      //filtre de la liste de commande
      this.listCommande = this.listCommande.filter(commande => {
        return commande.priorite == priorite;
      });
    },

    loadDemande() {
      this.loading = true;
      this.listDemande = [];
      let url = this.domaine + "entrepot/liste";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listDemande = response.body.demande;
          this.loading = false;
        }
      });
    },

    loadFourn() {
      this.loading = true;
      let url = this.domaine + "fournisseur/index";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listFour = response.body.fournisseur;
          this.loading = false;
        }
      });
    },
    loadTravaux() {
      this.loading = true;
      this.travauxS = "";
      this.listTravaux = [];
      if (this.chantierS != "" && this.chantierS != null) {
        let url =
          this.domaine + "projet/" + this.chantierS + "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },

    loadTacheTrx() {
      this.loading = true;
      this.tacheS = "";
      this.listeTacheTrx.splice(0);
      if (this.travauxS != "" || this.travauxS !== undefined) {
        let url = this.domaine + "tache/travaux/" + this.travauxS;
        this.$http.get(url).then(response => {
          this.listeTacheTrx = response.body.taches;
          this.loading = false;
        });
      } else {
        this.$message.error("Veuillez sélectionner une tache");
        this.loading = false;
      }
    },

    //filtre
    loadDemandeur(userId) {
      this.selectEtatDate = null;
      this.listBesoin = this.oldListBesoin;
      this.listBesoin = this.listBesoin.filter(function(item) {
        return item.userId == userId;
      });
    },

    loadDate(date) {
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDemandeur = null;
      if(date) {
          this.listBesoin = this.listBesoin.filter(item => {
          if (item.dateJour >= date[0] && item.dateJour <= date[1])
            return item.dateJour;
          else if (item.dateJour == date[0] || item.dateJour == date[1])
            return item.dateJour;
        });
      }    
    },

    loadServiceBesoin(service) {
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.listBesoin = this.listBesoin.filter(besoin => {
        this.comboUser = this.oldComboUser;
        this.comboUser = this.comboUser.filter(user => {
          return user.serviceId == service;
        });
        return besoin.serviceId == service;
      });
    },

    filtrerEtatPrioriteBesoin(priorite) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      //filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(besoin => {
        return besoin.priorite == priorite;
      });
    },
    filtrerEtatConfirmationBesoin(etat) {
      //reinitialisation de la liste commande
      this.listBesoin = this.oldListBesoin;
      this.selectEtatDate = null;
      this.selectEtatService = null;
      this.selectEtatDemandeur = null;

      // filtre de la liste de commande
      this.listBesoin = this.listBesoin.filter(besoin => {
        return besoin.etat == etat;
      });
    },

    filtrerEtatService(service) {
      this.loadServiceBesoin(service);
    },

    filtrerEtatDemandeur(userId) {
      this.loadDemandeur(userId);
    },

    filtrerEtatDate(date) {
      if (this.selectEtatDate != null) this.loadDate(date);
      else this.listBesoin = this.oldListBesoin;
    },
    filtrerEntrepot(idEnt) {
      this.loadDmdParEntrp(idEnt);
    },
    filtrerCmdEntrepot(idEnt) {
      this.loadCmdParEntrp(idEnt);
    },
    filtrerTravaux(idTrx) {
      this.loadDmdParTrx(idTrx);
    },
    filtrerCommandeTravaux(idTrx) {
      this.loadCmdParTrx(idTrx);
    },
  filtreByChantier(idChantier) {
    this.listBesoin = this.oldListBesoin;
    if(idChantier == '' || idChantier == null) {
     this.listBesoin = this.oldListBesoin;
    }  
    this.listBesoin = this.listBesoin.filter(function(item) {
      return item.chantierId == idChantier;
    });
  },
  filtreByProjet(idProjet) {    
    this.listBesoin = this.oldListBesoin;
    if(idProjet == '' || idProjet == null) {
     this.listBesoin = this.oldListBesoin;
    }  
    this.listBesoin = this.listBesoin.filter(function(item) {
      return item.projetId == idProjet;
    });
  },
    loadCmdParTrx(idTrx) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function(item) {
        return item.travauxId == idTrx;
      });
    },

    loadDmdParTrx(idTrx) {
      this.listBesoin = this.oldListBesoin;
      //this.selectEtatDmd = null;
      this.listBesoin = this.listBesoin.filter(function(item) {
        return item.travauxId == idTrx;
      });
    },

    loadDmdParEntrp(idEnt) {
      this.listBesoin = this.oldListBesoin;
      //this.selectEtatDmd = null;
      this.listBesoin = this.listBesoin.filter(function(item) {
        return item.entrepotId == idEnt;
      });
    },

    loadCmdParEntrp(idEnt) {
      this.listCommande = this.oldListCommande;
      this.listCommande = this.listCommande.filter(function(item) {
        return item.entrepotId == idEnt;
      });
    },
    verifFormInfo(optionP) {
      if (optionP.unite != null) {
        return true;
      } else {
        return false;
      }
    },

    clearSelect() {
      this.listBesoin = this.oldListBesoin;
      this.comboUser = this.oldComboUser;
    },
     editRessources(ligne) {
      this.dialogShowEditRessource = true
      this.tacheSelectioner = ligne;
      this.formEditRessource.libelle = ligne.produit
      this.formEditRessource.qte = ligne.qte
      this.formEditRessource.dateD = ligne.dateDUtilisation
      this.formEditRessource.dateF = ligne.dateFUtilisation
    },
    resetFormEditRess() {
      this.formEditRessource= {}
      this.dialogShowEditRessource = false
    },
     sumbitRessource(ligne) {
       this.loading = true;
      var form = document.getElementById("formEditRessource");
      var data = new FormData(form);
      let url = "";
      data.append("dataForm", JSON.stringify(this.formEditRessource))
      data.append("idOptBesoin",ligne.id)
      data.append("idOptTravaux",ligne.idOptTravaux)
      data.append("idProd",ligne.idProd)
      data.append("idqte",ligne.qte)
      url = this.domaine + "projet/travaux/"+ligne.travauxId+ "/ressources/edit";
      this.$http.post(url, data).then(
        response => {
          this.loading = false;
          if (response.body) {
            let verif = response.body;
            this.loading = false;
            if (verif.code === 1) {
              this.$notify({
                title: "MODIFICATION REUSSI",
                message: response.body.message,
                type: "success",
                position: "top-center"
              });
               this.loading = false;
               this.dialogSuprRessource = false;
               this.dialogShowEditRessource = false;
                this.dialogShowTravaux = false
               this.formEditRessource.dateD = ''
               this.formEditRessource.dateD = ''
               this.loadRecentBesoin()
            }
          }
        },
        error => {
          this.loading = false;
          this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
          // this.loading = false;
        }
      );


    },

    //filtre
    loadUser() {
      this.loading = true;
      let url = this.domaine + "besoin/liste/utilisateur";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboUser = Object.values(response.body.user);
          this.oldComboUser = this.comboUser;
          this.loading = false;
        }
      });
    },

    loadService() {
      this.loading = true;
      let url = this.domaine + "besoin/liste/service";
      this.$http.get(url).then(response => {
        if (response.body) {
          this.comboService = Object.values(response.body.service);
          this.loading = false;
        }
      });
    },
    //Imprimer la liste des besoins
    imprimeListeBesoin(type) {
      let url = "";
      if (type == "PDF") {
          url = this.domaine + "besoin/imprimerPDF/liste";
        } else {
          url = this.domaine + "besoin/imprimerEXC/liste";
        }

      this.$http.get(url).then(response => {
          if (response.body) {
          }
      })
      window.open(url)
    },

    effacerChamp() {
      //this.optionBesoin.value="";
    },
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    generateFileExcel() {
      this.dialogImport = false
        let url = this.domaine + "besoin/generer/modele/besoin";
        window.open(url);
      },
      onFileExcelPicked(event) {
        this.loading = true;
        this.fileExcel.splice(0, 1);
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf(".xls") <= 0) {
          return alert("Veuillez selectionner un fichier excel valide ");
        }
        if (files[0].size > 2097152) {
          this.$message.error("La taille du fichier est supérieur à 2 Mo");
          return;
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.fileExcel.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[0]);

        let url = this.domaine + "besoin/loadData/excel";
        let data = new FormData();
        data.append("fichierExcel", files[0], files[0][name]);
        this.$http.post(url, data).then(
          resp => {
            this.loading = false;
            this.$notify({
              title: "Chargement des données",
              message: "Chargement effectué",
              type: "success",
              position: "top-right",
              duration: 7000
            });
            this.tableInventaire = resp.body.produit;
          },
          error => {
            this.loading = false;
            this.$message.error("Erreur lors de l'importation du fichier");
          }
        );
      },
    //Suppression
    deleteNeed() {
      var besoinId = this.recupIdSelection();

      this.$confirm("Voulez-vous supprimer cette selection?", "Attention", {
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        type: "warning"
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "Suppression en cours!"
          });
          this.loading = true;
          let besoinTabId = [];
          let i = 0;

          //envoie du tableau obtenu
          let url = this.domaine + "besoin/delete/selection/" + besoinId;
          this.$http.get(url).then(response => {
            if (response.ok) {
              this.loading = false;
              this.$notify({
                title: "SUPPRESSION REUSSIE",
                message: "La selection a été supprimée avec succès.",
                type: "success",
                position: "top-center"
              });
              this.loadRecentBesoin();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Suppression annulée"
          });
        });
    },

    recupIdSelection() {
      let besoinTabId = [];
      //recuperation des id de besoin
      this.multipleSelection.forEach(besoin => {
        besoinTabId.push(besoin.id);
      });
      return besoinTabId;
    },

    loadPage() {
      this.loading = true;
    },
    loadBesoin() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.besoin) {
        url = this.domaine + "besoin/index";
      } else {
        url = this.domaine + "besoin/index/" + this.user.id + "/user";
      }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listBesoin = response.body.besoin;
          this.listBesoinAttente = response.body.besoinAttente;
          this.oldListBesoin = response.body.besoin;
          if (this.oldListBesoin) this.disabledImprime = false;
          else this.disabledImprime = true;
          this.loading = false;
        }
      });
      this.loadUser();
      this.loadDate();
      this.loadService();
    },

    loadProduit(queryString, cb) {
      let url = this.domaine + "product/product-list";
      var formdata = new FormData();
      formdata.append("user", this.user.id);
      formdata.append("tag", queryString);
      this.$http.post(url, formdata).then(
        response => {
          if (response.body) {
            this.listProd = response.body;
            var links = response.body;
            var results = queryString
              ? links.filter(this.createFilter(queryString))
              : links;
            cb(results);
          }
        },
        response => {}
      );
    },
    loadRecentBesoin() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.besoin) {
        url = this.domaine + "besoin/index_recent";
      } else {
        url = this.domaine + "besoin/index/" + this.user.id + "/user/recent";
      }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listBesoin = response.body.besoin ? response.body.besoin : [];
          this.notification =  this.listBesoin.length
          this.listBesoinAttente = response.body.besoinAttente;
          this.oldListBesoin = response.body.besoin;
          if (this.oldListBesoin) this.disabledImprime = false;
          else this.disabledImprime = true;
          this.loading = false;
        }
      });
      this.loadUser();
      this.loadDate();
      this.loadService();
    },
    loadCommande() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.index_besoin_commande) {
        url = this.domaine + "besoin/index/commande";
      } else {
        url = this.domaine + "besoin/index/commande/" + this.user.id + "/user";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCommande = Object.values(response.body.commande);
          this.oldListCommande = this.listCommande;
          this.loading = false;
        }
      });
    },
    loadCommandeRecent() {
      this.loading = true;
      let url = "";
      if (this.droitAcces.index_besoin_commande) {
        url = this.domaine + "besoin/index/commande/recent";
      } else {
        url =
          this.domaine +
          "besoin/index/commande/recent/" +
          this.user.id +
          "/user";
      }
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listCommande = Object.values(response.body.commande);

          this.oldListCommande = this.listCommande;
          this.notifCommande = this.listCommande.length
          this.loading = false;
        }
      });
    },
    newBesoin() {
      this.dialogBesoin = true;
      this.dialogEdit = false;
      this.optionProduit = [
        {
          type: "",
          key: 1,
          produit: "",
          qte: 1,
          unite: "",
          id: "",
          priorite: ""
        }
      ];
      this.projetS = ''
      this.chantierS =''
      this.travauxS = ''
      this.tacheS =''
      this.dateLivrSouh = ''
      this.tableInventaire = [];
    },
    loadUniteProduit(item) {
      let valeur;
      valeur = this.listeProduitAffich.find(function(element) {
        if (element.value == item) {
          return element.unite;
        }
      });
      this.valeurUniteMateriel = valeur.unite;
    },
    newCommande() {
      this.loading = false;
      this.dialogComm = true;
      this.dialogEdit = false;
      this.optionCommande = this.multipleSelection;
      this.libelle = "";
      this.selectUsers = [];
      this.dateLivr = "";
      this.totalComTTC = 0;
      this.totComLigneTTCFormat = 0;
    },

    handleSelect(produit) {
      let index = this.optionBesoin.indexOf(produit);
      this.optionBesoin.splice(index, 3, produit);
    },

    editBesoin() {
      this.dialogBesoin = true;
      this.dialogEdit = true;
      this.optionBesoin = this.multipleSelection;
    },
    besoinSelect(row, index) {
      let etat = null;
      if (parseFloat(row.qte) != 0) {
        etat = true;
      } else {
        etat = false;
      }
      return etat;
    },
    submitBesoin() {
      this.loading = true;
      if (this.$refs.formBesoin.validate() && this.projetS && this.travauxS && this.tacheS) {
        let etat = false;
        if (this.tableInventaire.length > 0) {
          this.tableInventaire.forEach(function(item) {
            if (item.libelle != "" && item.qte > 0 && item.priorite != "") {
              etat = true;
            }
          });
        }

        if (etat == true) {
          var form = document.getElementById("formBesoin");
          let url = this.domaine + "besoin/new";
          
          let ligne = null;
          let nbData = 10;
          let nbReq = 1;

          let nbRest
          if (this.tableInventaire.length > 10) {
            nbData = 10;
            nbReq = Math.round(this.tableInventaire.length / nbData);
            let nbRest = this.tableInventaire.length % nbData;
            if (nbRest > 0) {
              nbReq += 1;
            }
          }
          
          for (let i=0; i<nbReq; i++) {

            let initJ = i * nbData;
            let finJ = (i + 1) * nbData;
            let dataLot = [];
            if (this.tableInventaire.length > 0) {
              for (let j = initJ; j < finJ; j++) {
                if (this.tableInventaire[j] == undefined) {
                  break;
                }
                dataLot.push(this.tableInventaire[j]);
              }
            }
          var formdata = new FormData(form);
          formdata.append("idUser", this.user.id);
          for (let prop in dataLot) {
            ligne = dataLot[prop];
            formdata.append("options[id][]", ligne.id);
            formdata.append("options[produit][]", ligne.libelle);
            formdata.append("options[qte][]", ligne.qte);
            formdata.append("options[unite][]", ligne.unite);
            formdata.append("options[priorite][]", ligne.priorite);

            formdata.append("projetId", this.projetS);
            formdata.append("chantierId", this.chantierS);
            formdata.append("travauxId", this.travauxS);
            formdata.append("tacheId", this.tacheS);
            formdata.append("entrepotId", this.selectDemande);
            formdata.append("typeDmd", this.typeDmd);
            formdata.append("dateLivrSouh", this.dateLivrSouh);
          }

          this.$http.post(url, formdata).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Besoin enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.dialogBesoin = false;
                  this.loadRecentBesoin();
                  this.selectDemande = ''
                  this.dateLivrSouh = ''
                  this.loading = false;
                  this.$refs.formBesoin.reset();
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
                this.clear();
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        }
        } else {
          this.$notify({
            title: "ATTENTION",
            message:
              "Vous devez obligatoirement enregistré des lignes pour le besoin et que ces lignes ont été correctements remplis.",
            position: "top-center",
            type: "warning"
          });
          this.loading = false;
        }
      } else {
        this.$message.error("Veuillez renseigner les champs obligatoires");
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La besoin n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },

    closeDialog() {
      this.$emit("close");
    },
    submitComm() {
      const dateNow = new Date().toISOString().slice(0, 10);

      // on change le format de la date pour  la comparaison  de date
      let tabDateDbt = this.dateLivr.split("-"); //["16","08","2018 00:00:00"]
        let jr = tabDateDbt[0];
        let mois = tabDateDbt[1];
        let annee = tabDateDbt[2].split(" ")[0];
        let dateDbt = annee + "-" + mois + "-" + jr;
      // this.loading = true;
      if (
        this.$refs.formComm.validate() &&
        this.libelle != "" &&
        this.dateLivr != "" &&
        this.selectFourn != "" &&
        dateNow <= dateDbt
      ) {
        let etat = false;
        if (this.optionCommande.length > 0) {
          this.optionCommande.forEach(function(item) {
            if (
              item.produit != "" &&
              item.prix > 0 &&
              item.qte > 0 &&
              item.unite != "" &&
              item.priorite > 0
            ) {
              etat = true;
            }
          });
        }

        if (etat == true) {
          var form = document.getElementById("formComm");
          let data = new FormData();
          let url=''
          data.append("libelle", this.libelle);
          data.append("dateLivr", this.dateLivr);
          data.append("priorite", this.priorite);
          data.append("total", this.totalComTTC);
          data.append("idUser", this.user.id);
          data.append("fournisseur", this.selectFourn);
          data.append("projetId", this.projetS);
          data.append("chantierId", this.chantierS);
          data.append("travauxId",  this.idTravaux );
          data.append("entrepotId", this.entrepotId);
          //on va enregister dabor la commande
          url = this.domaine + "besoin/commande/new";

           this.$http.post(url, data).then(
                    response => {
                        if (response.body) {
                        let verif = response.body;
                      url = this.domaine + "besoin/new/commande";
                      let nbData = 10;
                      let nbReq = 1;
                      let ligne = null;

                      let nbRest
                      if (this.optionCommande.length > 10) {
                        nbData = 10;
                        nbReq = Math.round(this.optionCommande.length / nbData);
                        nbRest = this.optionCommande.length % nbData;
                        if (nbRest > 0) {
                          nbReq += 1;
                        }
                      }


                      this.totalComTTC = 0;
                      for(let i=0; i<nbReq;i++)
                          {
                              let initJ = i*nbData;
                              let finJ = (i + 1) * nbData;
                              let dataLot = [];
                              if(this.optionCommande.length > 0){
                                  for(let j = initJ;j < finJ;j++){
                                      if(this.optionCommande[j] == undefined){
                                          break ;
                                      }
                                      dataLot.push(this.optionCommande[j]);
                                  }
                              }
                              let data = new FormData();
                              for (let prop in dataLot) {
                                  ligne = dataLot[prop];
                                  data.append("options[id][]", ligne.id);
                                  data.append("options[produit][]", ligne.produit);
                                  data.append("options[prix][]", ligne.prix);
                                  data.append("options[qte][]", ligne.qte);
                                  data.append("options[unite][]", ligne.unite);
                                  data.append("options[tva][]", ligne.tva);
                                  data.append("options[total][]", ligne.total);
                                  this.totalComTTC += ligne.total;
                                }

                            data.append("idCommande", verif.idCommande);
                            data.append("total", this.totalComTTC);
                            data.append("idUser", this.user.id);
                            data.append("fournisseur", this.selectFourn);
                            data.append("projetId", this.projetS);
                            data.append("chantierId", this.chantierS);

                            data.append("travauxId",  this.idTravaux );
                            // data.append("travauxId", this.multipleSelection[0]["travauxId"]);
                            data.append("otpionBesoinSelect", JSON.stringify(this.otpionBesoinSelect));                            

                              this.$http.post(url, data).then(
                                  response => {
                                      if (response.body) {
                                  let verif = response.body;
                                  if (verif.code === 1) {
                                    this.$notify({
                                      title: "ENREGISTREMENT REUSSI",
                                      message: "Commande enregistrée avec succès.",
                                      type: "success",
                                      position: "top-center"
                                    });

                                    this.dialogComm = false;
                                    this.loadCommandeRecent();
                                    this.loadRecentBesoin();
                                    this.$refs.formComm.reset();
                                  } else if (verif.code === 2) {
                                    this.$message.error(verif.message);
                                    this.loading = false;
                                  }
                                } else {
                                  this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                                  this.loading = false;
                                  this.clear();
                                  }
                                  },
                                  error => {
                                      this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                                    this.loading = false;
                                  }
                              )
                          }
                    }
                },
                error => {
                    this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                  this.loading = false;
                }
            )

        } else {
          this.$notify({
            title: "ATTENTION",
            message:
              "Vous devez obligatoirement enregistré des lignes pour la commande et que ces lignes ont été correctements remplis , les prix des produits doivent etre obligatoirement superieur a 0.",
            position: "top-center",
            type: "warning"
          });
          this.loading = false;
        }
      } else {
        this.$message.error(
          "Veuillez renseigner les champs obligatoires ou verifier que la date est superieur de la date d'aujourd'hui"
        );
        this.$notify.error({
          title: "ERREUR D'ENREGISTREMENT",
          message: "La commande n'a pas été enregistré.",
          position: "top-center"
        });
        this.loading = false;
      }
    },
    loadTypeProduit(item) {
      this.loading = true;
      let url = this.domaine + "product/productSelect/type/" + item;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProduitAffich = response.body.produits;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },
    calculTotalBe() {},

    //Notifications
    showNotification() {
      let url = this.domaine + "besoin/affiche/notification/" + this.user.id;

      //recuperation des notifications
      this.$http.get(url).then(response => {
        if (response.body) this.notification = response.body.notification;
      });
    },

    verifPrioriteBesoin() {
      let tabPrioriteProd = [];
      let prioriteFinal = 0;

      //Recuperation des priorites des besoins
      this.multipleSelection.forEach(produit => {
        tabPrioriteProd.push(produit.priorite);
      });

      //Verification et des niveaux de priorite
      for (let i = 0; i < tabPrioriteProd.length; i++) {
        if (tabPrioriteProd[i] === 3) {
          prioriteFinal = 3;
          break;
        } else if (tabPrioriteProd[i] === 2) {
          //Control de l'existence d'une priorité plus haute
          for (let i = 0; i < tabPrioriteProd.length; i++) {
            if (tabPrioriteProd[i] === 3) {
              prioriteFinal = 3;
              break;
            } else {
              prioriteFinal = 2;
            }
          }
          break;
        } else {
          prioriteFinal = 1;
        }
      }

      //Attributon de la valeur de la priorite
      this.priorite = prioriteFinal;
    },
    addListInventaire(item) {
      this.tableInventaire.push({
        code: item.codeGestion ? item.codeGestion :'non defini',
        type: item.type ? item.type : 'VEHICULE/ENGIN',
        libelle: item.produit,
        etat: item.etat,
        unite:  this.typeDmd != 'Carburant' ? this.valeurUniteMateriel : 'Litre',
        qte: item.qte,
        priorite: item.priorite
      });
      this.optionProduit = [
        { type: "", produit: "", qte: 1, unite: "", priorite: "" }
      ];
      this.formInventaire = {};
      this.valeurUniteMateriel = "";
    },


    // addListInventaire(item) {
    //   let valeur = "";
    //      switch (item.type) {
    //     case "1":
    //       valeur = "MATÉRIEL";
    //       break;
    //     case "2":
    //       valeur = "MATÉRIAUX";
    //       break;
    //     case "3":
    //       valeur = "SERVICE";
    //       break;
    //     case "4":
    //       valeur = "VÉHICULE";
    //       break;
    //     case "5":
    //       valeur = "AUTRE";
    //       break;
    //     case "6":
    //       valeur = "FOURNITURE";
    //     break;
    //     case "7":
    //        valeur = "PERSONNEL";
    //     break;
    //     case "8":
    //      valeur = "PIECES DETACHEES";
    //     break;
    //     default:
    //       valeur = "MATÉRIEL";
    //     break;
    //     }

      
    //   this.tableInventaire.push({
    //     type: valeur,
    //     libelle: item.produit,
    //     etat: item.etat,
    //     unite: this.valeurUniteMateriel,
    //     qte: item.qte,
    //     priorite: item.priorite
    //   });
    //   this.optionProduit = [
    //     { type: "", produit: "", qte: 1, unite: "", priorite: "" }
    //   ];
    //   this.formInventaire = {};
    //   this.valeurUniteMateriel = "";
    // },
    removeOptionBesoin(item) {
      var index = this.optionBesoin.indexOf(item);
      this.totTTC -= this.optionBesoin[index].total;
      if (index !== -1) {
        this.optionBesoin.splice(index, 1);
      }
      this.calculTotalBe();
    },
    calculTotalComm() {
      this.totComLigneTTC = 0;
      let totalHT = 0;
      let totalTVA = 0;
      for (let prop in this.optionCommande) {
        let currentC = this.optionCommande[prop];
        totalHT += currentC.prix * currentC.qte;
        totalTVA += Math.round(
          currentC.prix * currentC.qte * (currentC.tva / 100)
        );
        let tot =
          currentC.prix * currentC.qte +
          Math.round(currentC.prix * currentC.qte * (currentC.tva / 100));
        this.optionCommande[prop].total = tot;
        this.totComLigneTTC += tot;
      }
      this.totalComHT = new Intl.NumberFormat("fr-Fr").format(totalHT);
      this.totalComTVA = new Intl.NumberFormat("fr-Fr").format(totalTVA);
      this.totalComTTC = this.totComLigneTTC;
      this.totComLigneTTCFormat = new Intl.NumberFormat("fr-Fr").format(
        this.totComLigneTTC
      );
    },
    removeOptionComm(item) {
      var index = this.optionCommande.indexOf(item);
      this.totTTC -= this.optionCommande[index].total;
      if (index !== -1) {
        this.optionCommande.splice(index, 1);
      }
      this.calculTotalComm();
    },
    querySearch(queryString, cb) {
      var links = this.listKeyword;
      var results = queryString
        ? links.filter(this.createFilter(queryString))
        : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return link => {
        return (
          link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelectionChange(val) {
      let factNull = false;
      //verification de l'etat
      let dataFact = val.filter((elt, index) => {
        if (elt.etat == 1) {
          this.$refs.multipleTable.toggleRowSelection(elt);
          factNull = true;
        }
        return elt.etat == 1;
      });

      //  this.multipleSelection = dataFact
      this.multipleSelection = val;
      this.nombreSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnValide = true;
        this.choix = true;
      } else {
        this.disabledBtnValide = false;
        this.choix = false;
      }

      if (factNull == true) {
        this.$message({
          message:
            "Attention, vous ne pouvez selectionner que les besoins deja validé",
          type: "warning",
          duration: 1000
        });
      }    
    },
    beforeMount: function() {
      if (!this.roleAcces[this.$router.history.current.name]) {
        this.$router.push({ name: "Home" });
      }
    },

    //Projet
    selectProjet(idProjet) {
      this.loadChantier(idProjet);
    },

    loadProjet() {
      let url = this.domaine + "projet/index/projet/all";

      this.loading = true;
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeProjet = response.body.projet;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste des projets"
          );
        }
      );
    },

    loadChantier() {
      if (this.projetS == "" || this.projetS == null) {
        return;
      }
      this.loading = true;
      this.listeChantier.splice(0);
      this.listeTacheTrx.splice(0);
      this.listeTravaux.splice(0);

      (this.chantierS = ""), (this.travauxS = "");
      this.tacheS = "";

      let url = this.domaine + "projet/" + this.projetS + "/index/chantier";
      this.$http.get(url).then(
        response => {
          this.loading = false;
          this.listeChantier = response.body.chantier;
        },
        errRep => {
          this.loading = false;
          this.$message.error(
            "Une erreur est survenue lors du chargement de la liste du chntier"
          );
        }
      );
    },

    loadProduitFoun(ligne) {
      this.loading = true;
      this.fournCourant = ligne;
      let url = "";
      // if (this.droitAcces.index_produit_fourn) {
        url =
          this.domaine +
          "fournisseur/" +
          this.fournCourant.id +
          "/index/produit";
      // } else {
      //   url =
      //     this.domaine +
      //     "fournisseur/" +
      //     this.fournCourant.id +
      //     "/index/" +
      //     this.user.id +
      //     "/produit";
      // }

      this.$http.get(url).then(response => {
        if (response.body) {
          this.listProduit = response.body.produit;
          this.loading = false;
        }
      });
    },
    closeDialogComp() {
      this.showModalDetailCmd = false;
      //this.loadCommande()
      //this.loadBesoin()
    },
    imprimerListe() {
      this.loading = true;
      this.optionCommande = this.multipleSelection;
      let options = [];
      var formdata = new FormData();
       for (let prop in this.optionCommande) {
        let ligne = this.optionCommande[prop];
          options.push(ligne.id);
      }

      let  url = this.domaine + "comparateur/imprimerPDF/listePrixFourn";
      formdata.append("options", options);
      formdata.append("typeOption", 2); //optionBesoin

      let req=new XMLHttpRequest();
      this.$http
        .post(url, formdata, { responseType: "arraybuffer" })
        .then(response => {
          let blob = new Blob([response.data], {
            type: response.headers.get("content-type")
          });

          let url = URL.createObjectURL(blob);
          this.loading = false;
          window.open(url);
        });
    },

    showDialogComparaison() {
      this.loading = true;
      this.dialogComm = false
      this.optionCommande = this.multipleSelection;
      var formdata = new FormData();
      let url = this.domaine + "comparateur/new/commande";
      let options = [];
      let listProdPrixNulle = [];
      let smsAficher =
        "Aucune tarification de ce produit est indiqué chez vous fournisseurs ";
      let mesProdPrixNulle =
        "Les produits de cette commande ne se trouvent chez aucun de vos fournisseurs ";

      for (let prop in this.optionCommande) {
        let ligne = this.optionCommande[prop];
          options.push(ligne.id);
      }
      formdata.append("options", options);
      formdata.append("typeOption", 2); //optionBesoin

      this.$http.post(url, formdata).then(
        response => {
          //affichage des messages
          let nbCmd = 0;
          let nbCmdDeux = 0
          let listeFoun = [];
          let listeNull = [];
          let listeFounSecond = []
          if (response.body.code == 1) {
            var nbProdNull = response.body.listeProdNull.length;
            let messages = response.body.messageProd;
            let mes = "";
            //recuperer les message
            for (var index in messages) {
              mes += "-- " + messages[index];
            }

            this.$confirm(mes, "Avertissement", {
              confirmButtonText: "Continuer",
              cancelButtonText: "Annuler",
              type: "warning"
            })
              .then(() => {
                const respFour = response.body.fournisseurs[0];
                this.mntTotalCmd = response.body.mntTotauxFormat;
                this.listeProdNull = response.body.listeProdNull;

                //let listeFoun = [];
                for (let four in respFour) {
                  nbCmd++;
                  let listeProduit = respFour[four];
                  let infoFour = {
                    fournisseur: four,
                    produits: [],
                    mntTotal: 0,
                    mntTotalHt: 0,
                  };

                  for (let produit of listeProduit) {
                    infoFour.produits.push(produit);
                    infoFour.mntTotal += parseFloat(produit.mntTotal);
                    infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
                  }
                  listeFoun.push(infoFour);
                }

                this.nbCommandeSug = nbCmd;
                this.commandeDeriv = listeFoun;

                this.dialogDetailCmd = true;
                this.loading = false;

                //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
                if (response.body.listeProdNull.length > 0) {
                  this.dialogProdNull = true;
                  //this.closeProdNull();
                }
                if (listeFoun.length > 0) {
                  this.showModalCompCmd = true;
                }
              })
              .catch(() => {
                this.loading = false
                this.showModalCompCmd = false;
                this.$alert(smsAficher, {
                    confirmButtonText: "OK"
                  });
              });
          } else {
            const respFour = response.body.fournisseurs[0];
            this.mntTotalCmd = response.body.mntTotauxFormat;
            this.listeProdNull = response.body.listeProdNull;
             if (respFour.length == 0) {
                this.loading = false;
                this.$alert(mesProdPrixNulle, "", {
                  confirmButtonText: "OK"
                });
                return
              }
              this.loading = false;
              this.dialogComm = false
              this.showModalCompCmd = false;
            for (let four in respFour) {
              let listeProduit = respFour[four];
              let infoFour = {
                fournisseur: four,
                produits: [],
                mntTotal: 0,
                mntTotalHt: 0,

              };
              for (let produit of listeProduit) {
                infoFour.produits.push(produit);
                infoFour.mntTotal += parseFloat(produit.mntTotal);
                infoFour.mntTotalHt += parseFloat(produit.mntTotalHt);
              }

                  if(infoFour.produits.length == options.length)
                  {
                    nbCmd++;
                    listeFoun.push(infoFour);
                  }else {
                    nbCmdDeux++;
                    listeFounSecond.push(infoFour);
                  }


            }

            this.nbCommandeSug = nbCmd;
            this.commandeDeriv = listeFoun;
            this.nbCommandeSugDeux = nbCmdDeux;
            this.commandeDerivDeux = listeFounSecond;
            this.dialogDetailCmd = true;
            this.loading = false;
            //AFFICHAGE DE PRODUITS DONT LE MONTANT EST NULL
            if (response.body.listeProdNull.length > 0) {
              this.dialogProdNull = true;
            }

            if (listeFoun.length > 0) {
              this.showModalCompCmd = true;
            }
          }
          this.infOrenseigner = [this.libelle, this.dateLivr,this.priorite,this.projetLib,this.travuxLib,this.chantieretLib,this.idTravaux,this.entrepotLib]
          this.dialogComm = false
          this.showModalCompCmd = true;
        },
        error => {
          this.loading = false;
          this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
        }
      );
    },
    genererListe() {      
      let produit  = []
      let qte  = []          
      for (let prop in this.optionCommande) {
        let ligne = this.optionCommande[prop];          
         produit.push(ligne.idProd)
          qte.push(ligne.qte)
      }
       let  url = this.domaine + "besoin/imprimerEXC/recherche/liste/"+produit+'/'+qte;
      this.loading = false
      window.open(url);
    }
  },

  watch: {
    activDerouler: function(newValue, oldValue) {
      if (newValue) {
        this.showNotification();
        this.loadProjet();
      }
    }
  },

  computed: {},
  mounted() {
    this.loadPage();
    this.loadCommandeRecent();
    this.loadRecentBesoin();  
    this.loadTypeRessource();
    this.loadProjet();
    this.loadDemande();
  }

};

</script>

<style>
.btnV {
  width: 100%;
  height: 80px;
}

.notification {
  margin-left: 620px;
}
</style>



// WEBPACK FOOTER //
// src/components/Besoin.vue